export default __webpack_public_path__ + "static/media/departmentWiseResponsible.b09d9fb2.svg";